module.exports = {"321302001":"幸福街道","321302002":"项里街道","321302003":"河滨街道","321302004":"古城街道","321302100":"双庄镇","321302101":"耿车镇","321302102":"埠子镇","321302103":"龙河镇","321302104":"洋北镇","321302107":"中扬镇","321302109":"陈集镇","321302110":"蔡集镇","321302111":"王官集镇","321302150":"洋河镇","321302151":"仓集镇","321302152":"郑楼镇","321302201":"罗圩乡","321302203":"屠园乡","321302400":"宿城开发区","321302450":"苏州宿迁工业园"}


//////////////////
// WEBPACK FOOTER
// ./src/town/321302.json
// module id = 860
// module chunks = 0